import type { Session } from "@supabase/supabase-js";

// Device convenience only, never an authentication or role grant. Auth owns
// token refresh/revocation; the normal server and role checks remain mandatory.
export const TRUST_DURATION_MS = 7 * 24 * 60 * 60 * 1000;
export const TRUST_KEY = "evohome.staff.deviceTrust.v1";
export function sessionIdentity(session: Pick<Session, "access_token"> | null | undefined): string | null {
  try {
    const payload: unknown = JSON.parse(atob((session?.access_token.split(".")[1] ?? "").replace(/-/g, "+").replace(/_/g, "/")));
    if (!payload || typeof payload !== "object" || !("session_id" in payload)) return null;
    return typeof payload.session_id === "string" && /^[a-f0-9-]{36}$/i.test(payload.session_id) ? payload.session_id : null;
  } catch { return null; }
}
export function clearDeviceTrust() {
  try { localStorage.removeItem(TRUST_KEY); } catch { /* unavailable means no trust */ }
}
export function rememberDevice(userId: string, sessionId: string | null, now = Date.now()): boolean {
  clearDeviceTrust();
  if (!sessionId) return false;
  try {
    localStorage.setItem(TRUST_KEY, JSON.stringify({ userId, sessionId, issuedAt: now, expiresAt: now + TRUST_DURATION_MS }));
    return trustedUntil(userId, sessionId, now) === now + TRUST_DURATION_MS;
  } catch { return false; }
}
export function trustedUntil(userId: string, sessionId: string | null, now = Date.now()): number | null {
  try {
    const t = JSON.parse(localStorage.getItem(TRUST_KEY) ?? "null");
    if (!t || !sessionId || t.userId !== userId || t.sessionId !== sessionId ||
      !Number.isFinite(t.issuedAt) || !Number.isFinite(t.expiresAt) || t.issuedAt > now ||
      t.expiresAt <= now || t.expiresAt <= t.issuedAt || t.expiresAt - t.issuedAt > TRUST_DURATION_MS) return null;
    return t.expiresAt;
  } catch { return null; }
}